import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { getTypography } from '../../styles/typography'

const Typography = React.forwardRef(
	({ size, children, color, component, to, fontWeight, textAlign }, ref) => {
		const navigate = (link) => link
		const onClick = useMemo(() => (to ? navigate : undefined), [to])

		const as = useMemo(() => {
			if (component) {
				return component
			}

			const tag = {
				xxl: 'h1',
				xl: 'h2',
				l: 'h3',
				m: 'h4',
				s: 'h5',
			}[size]

			return tag || (size.includes('paragraph') ? 'p' : 'span')
		}, [component, size])

		return (
			<Text
				ref={ref}
				size={size}
				color={color}
				fontWeight={fontWeight}
				textAlign={textAlign}
				as={as}
				onClick={onClick}
			>
				{children}
			</Text>
		)
	}
)

Typography.propTypes = {
	children: PropTypes.node.isRequired,
	color: PropTypes.string,
	component: PropTypes.string,
	to: PropTypes.string,
	size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
	textAlign: PropTypes.oneOf(['start', 'center', 'end']),
	fontWeight: PropTypes.oneOf([400, 500, 700]),
}

Typography.defaultProps = {
	color: '',
	component: '',
	to: '',
	size: 'md',
	textAlign: 'start',
	fontWeight: 400,
}

export default Typography

const Text = styled.span`
	${({ size }) => getTypography(size)};
	color: ${({ color }) => color && color};
	text-align: ${({ textAlign }) => textAlign};
	font-weight: ${({ fontWeight }) => fontWeight};
`
